package com.appsyde.shared.modules.ai.data.repository

import com.appsyde.shared.modules.ai.data.dto.AiGenerateRequestV2
import com.appsyde.shared.modules.ai.data.dto.AiPreloadRequestV2
import com.appsyde.shared.modules.ai.data.dto.AiRefineRequest
import com.appsyde.shared.modules.ai.data.source.AiRemoteDataSource
import com.appsyde.shared.modules.ai.domain.model.AiRefineAction
import com.appsyde.shared.modules.ai.domain.repository.AiRepositoryV2


class AiRepositoryV2Impl(
    private val remote: AiRemoteDataSource
) : AiRepositoryV2 {

    override suspend fun generateExtractJson(messageId: String, force: Boolean): String {
        val dto = remote.generateExtract(AiGenerateRequestV2(messageId = messageId, force = force))
        return dto.text
    }

    override suspend fun regenerateContextJson(messageId: String): String {
        return remote.regenerateContext(messageId).text
    }

    override suspend fun refineText(text: String, action: AiRefineAction): String {
        val dto = remote.refine(AiRefineRequest(action = action, text = text))
        return dto.text
    }

    override suspend fun preloadByMessageIds(messageIds: List<String>, force: Boolean) {
        if (messageIds.isEmpty()) return
        remote.preloadByMessageIds(AiPreloadRequestV2(messageIds = messageIds, force = force))
    }
}
